import { Injectable } from "@angular/core";
import { MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { StudentDetailsFormDataService } from "common/services/data-services/admin/students/student-details-form.data.service";
import { SystemService } from "common/services/core-services/system.service";
import { API_URL } from "common/constants/sm-constants";
import { documentListDataService } from "common/services/data-services/custom-service/documentlist-service";
import { environment } from "src/environments/environment";
import { UploadFileModel } from "common/models/page-models/custom-model/uploadfile.model";
import { MentorFeedback } from "common/models/page-models/student-details/mentor-feedback-model";
import { StudentDetailsMetaModel } from "common/models/page-models/student-details/student-details-meta-model";
import { StudentDetailsModel } from "common/models/page-models/student-details/student-details-model";
import { studentInternshipDataModel } from "common/models/page-models/student-details/student-internship-data-model";
import { StudentInternShipKeyDetails } from "common/models/page-models/student-details/student-internship-key-details-model";
import { MentorMappingListDataService } from "common/services/data-services/custom-service/mentor-list-service";
import moment from "moment";
import { StudentFeedback } from "common/models/page-models/student-details/student-feedback-details-model";
import { DistrictDataService } from "common/services/data-services/custom-service/district-data.service";



@Injectable({
  providedIn: 'root'
})
export class StudentDetailsWidgetService extends FormWidgetService<StudentDetailsModel> {
  constructor(protected ds: StudentDetailsFormDataService, public ss: SystemService, private documentListServive: documentListDataService, private mentorListService: MentorMappingListDataService, private districtService: DistrictDataService) {
    super(ds);
  }


  override async prepareMetaModel(dataModel: StudentDetailsModel, metaModel: StudentDetailsMetaModel, routeData: WidgetModel): Promise<StudentDetailsMetaModel> {
    try {
      // Fetch mentor list and set the mentor options
      const mentorData = await this.mentorListService.postData('');
      metaModel.properties.mentorId.options = mentorData['details'];
  
      // Fetch district data and set the district options
      const districtData = await this.districtService.postData({ state_id: dataModel.state_id });
      metaModel.properties.district_id.options = districtData.details;
      // console.log(metaModel.properties.district_id.options);
  
      // Set static options
      metaModel.properties['state_id'].options = this.ss.dataStorage.state_List;
      metaModel.properties['region_id'].options = this.ss.dataStorage.zone_name;
      metaModel.properties['batch_number'].options = this.ss.dataStorage.batch_number;
      metaModel.properties['placement_company_package'].options = this.ss.dataStorage.package_list;
      metaModel.properties['branch_name'].options = this.ss.dataStorage.branch_list;
  
      // Set MentoringDocument properties
      metaModel.properties['MentoringDocumentMetaModel']['properties'].showHeader = false;
      metaModel.properties['MentoringDocumentMetaModel']['properties'].isEditable = false;
      metaModel.properties['MentoringDocumentMetaModel']['properties'].isDeletable = true;
      metaModel.properties['MentoringDocumentMetaModel']['properties'].isSelectAll = false;
      metaModel.properties['MentoringDocumentMetaModel']['properties'].isSearch = true;
  
      // Fetch document list and merge with student data
      const documentData = await this.documentListServive.postData({});
      dataModel.studentDocumentDetailsList = documentData.details;
      // console.log(documentData.details);
  
      const mergedData = await this.mergeArrays(documentData.details, dataModel.apiStudentDocumentDetailsList, 'id', 'documentTypeId', String(dataModel.year));
      dataModel.studentDocumentDetails = mergedData;
  
      // Fetch internship details
      const internshipData = await this.ds.setSystemServiceData('details', API_URL.studentInternshipDetail, { studentId: routeData.transferData.id }, 'details');
      // console.log(internshipData);
  
      if (internshipData.hasOwnProperty('details') && internshipData.details.length > 0) {
        // console.log(internshipData.details);
        dataModel.isInternshipCertyVerified = internshipData.details[0].isInternshipCertyVerified;
        dataModel.internshipCertificateFilename = internshipData.details[0].internshipCertificateFilename;
        // console.log(dataModel.internshipCertificateFilename);
  
        // Process each internship element
        for (const element of internshipData.details) {
          const prepareInternShipData: studentInternshipDataModel = new studentInternshipDataModel();
          // console.log(element);
  
          if (element.internshipTitle) {
            // console.log(element.internshipTitle);
            prepareInternShipData.studentInternshipTitle = `${element.internshipTitle} (Semester - ${element.studentSemester})`;
          } else {
            prepareInternShipData.studentInternshipTitle = `(Semester - ${element.studentSemester})`;
          }
  
          // Process internship sub-title and feedback data
          for (const details of prepareInternShipData.studentInternshipSubTitle) {
            // console.log(details);
            for (const [index, labels] of details.showLabels.entries()) {
              const keyValue = new StudentInternShipKeyDetails();
              keyValue.showLabel = labels;
              let value = element[details.keyLabels[index]];
  
              if (value === '0') value = 'NO';
              else if (value === null) value = 'N/A';
              else if (value === '1') value = 'YES';
              else if (isValidDate(value)) value = formatDate(value);
              else if (value === '0000-00-00 00:00:00') value = 'N/A';
  
              keyValue.showValue = value;
              details.keyDetails.push(keyValue);
            }
          }
  
          // Helper function to check if a string is a valid date
          function isValidDate(dateString: string): boolean {
            return moment(dateString, moment.ISO_8601, true).isValid();
          }
  
          // Helper function to format a date string to DD/MM/YYYY
          function formatDate(dateString: string): string {
            return moment(dateString).format('DD MMMM YYYY');
          }
  
          // Process student feedback
          const newStudentFeedBack = new StudentFeedback();
          // console.log(element);
  
          for (const feedBack of element.studentFeedback) {
            const keyValue = new StudentInternShipKeyDetails();
            keyValue.showLabel = feedBack.question;
            keyValue.questionType = feedBack.questionType;
  
            if (feedBack.questionType === 1) {
              feedBack.options.filter((question) => {
                if (question.optionId === feedBack?.answer) {
                  keyValue.showValue = question.option_text;
                }
              });
            } else if ([2, 4, 0].includes(feedBack.questionType)) {
              keyValue.showValue = feedBack?.answer;
            } else if (feedBack.questionType === 3) {
              keyValue.showValue = feedBack?.starList;
            }
  
            newStudentFeedBack.keyDetails.push(keyValue);
          }
  
          // Process mentor feedback
          const newFeedBack = new MentorFeedback();
          for (const feedBack of element.mentorFeedback || []) {
            const keyValue = new StudentInternShipKeyDetails();
            keyValue.showLabel = feedBack.question;
            keyValue.questionType = feedBack.questionType;
  
            if (feedBack.questionType === 1) {
              keyValue.showValue = feedBack.answer;
            } else if ([2, 4, 0].includes(feedBack.questionType)) {
              keyValue.showValue = feedBack?.answer;
            } else if (feedBack.questionType === 3) {
              keyValue.showValue = feedBack?.starList;
            }
  
            newFeedBack.keyDetails.push(keyValue);
          }
  
          if (element?.mentorFeedback?.length) {
            const keyValue = new StudentInternShipKeyDetails();
            keyValue.showLabel = 'Status to Mentor';
            keyValue.showValue = 'Completed';
            keyValue.questionType = 1;
            newFeedBack.keyDetails = [keyValue, ...newFeedBack.keyDetails];
          }
  
          // Push the feedback data to the internship data
          prepareInternShipData.studentInternshipSubTitle.push(newStudentFeedBack, newFeedBack);
          prepareInternShipData.mentorFeedBack = newFeedBack;
          prepareInternShipData.studentFeedback = newStudentFeedBack;
          dataModel.details.push(prepareInternShipData);
        }
      }
  
      return metaModel;
    } catch (error) {
      console.error('Error in prepareMetaModel:', error);
      throw error; // Rethrow the error to be handled by the caller
    }
  }
  
  
  getMetaModel(): MetaModel {
    const meta = new StudentDetailsMetaModel();
    return meta.getMetaModel();
  }


  initToggle(url, payload) {
    // let formData = new FormData();

    // Object.keys(payload[0]).forEach(key => {
    //   formData.append(key, payload[0][key]);
    // });


    this.ds.postDataToCustomEndPoint(payload, null, environment.apiUrl + url, false).then((data) => {
      this.ss.showSuccess(data['msg'])
    })
  }

  mergeArrays(array1, array2, key1, key2, periodValue): Promise<any> {
    // console.log(array1, array2, key1, key2, periodValue);

    return new Promise((resolve, reject) => {
      try {
        const merged = [];
        const map = new Map();

        array1.forEach((item) => {
          map.set(item[key1], { ...item });
        });
        // console.log(map);


        const newArray = array2.filter((data) => {
          // console.log(periodValue);

          // console.log(data.periodValue);

          return data.periodValue == periodValue;
        });
        // console.log(newArray);


        newArray.forEach((item) => {
          // console.log(item);

          if (map.has(item[key2])) {
            map.set(item[key2], { ...map.get(item[key2]), ...item });
          } else {
            map.set(item[key2], { ...item });
          }

        });
        // console.log(map);

        map.forEach((data) => {

          const updateData = new UploadFileModel();
          updateData.documentTypeId = data.id;
          updateData.uploadDocId = data.UploadDocID;
          updateData.fileName = data.document_name;
          updateData.uploadedFileOriginalName = data.UploadedFileName;
          updateData.isAnnual = data.isAnnual;
          updateData.periodValue = periodValue;
          updateData.filePath = data.UploadedFileOriginalName;
          merged.push(updateData);
          // console.log(updateData);

        });

        resolve(merged);
      } catch (error) {
        reject(error);
      }
    });
  }


  markAttendance(event: any) {
    // Toggle the attended_flag based on the current state
    const updatedFlag = event.row.attended_flag === 0 ? 1 : 0;

    const payload = {
      assignment_id: event.row.assignment_id,
      attended_flag: updatedFlag, // Updated value
      student_id: event.row.student_id,
    };

    this.ds.postDataToCustomEndPoint(payload, null, environment.apiUrl + API_URL.evaluateStudentUpdate, false)
      .then((data) => {
        this.ss.showSuccess(data['msg']);

        // Update the row's attended_flag after successful update
        event.row.attended_flag = updatedFlag;
      })
      .catch((error) => {
        this.ss.showError('Failed to update attendance. Please try again.');
        console.error(error);
      });
  }



  // markReimbursementApproved(event) {
  //   const payload = {
  //     student_id: event.student_id,
  //     travelId: event.id,
  //     isApproved: event.isApproved
  //   }
  //   this.ds.postDataToCustomEndPoint(payload, null, environment.apiUrl + API_URL.editTravelReimbursement).then((data) => {
  //     this.ss.showSuccess(data['header'].msg)
  //   })
  // }



  // Save(body, url) {
  //   this.ds.postLoginData(body, url).then((response) => {
  //     if (response.header.type === 'success') {
  //       this.ss.showSuccess(response.header.msg);
  //     }

  //   });
  // }
}
